var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5413 2.37599C32.1448 3.36106 30.5986 4.11449 28.9622 4.60724C28.0839 3.59736 26.9166 2.88159 25.6183 2.55672C24.3199 2.23185 22.9531 2.31357 21.7027 2.79082C20.4523 3.26807 19.3787 4.11783 18.6269 5.22516C17.8752 6.3325 17.4817 7.64398 17.4997 8.98224V10.4406C14.9368 10.507 12.3974 9.93864 10.1074 8.78602C7.81743 7.6334 5.84805 5.93234 4.37467 3.83433C4.37467 3.83433 -1.45866 16.9593 11.6663 22.7927C8.66294 24.8314 5.08511 25.8536 1.45801 25.7093C14.583 33.001 30.6247 25.7093 30.6247 8.93849C30.6233 8.53228 30.5843 8.12707 30.508 7.72808C31.9964 6.26025 33.0467 4.40703 33.5413 2.37599V2.37599Z",
    stroke: "#0073FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.020a72cef23f4c0673f7d854eb77343b.svg";
export { ForwardRef as ReactComponent };